import { useContext, useEffect } from "react"
import { Navigate } from "react-router-dom"
import Loading from "../common/components/ui/loading/Loading"
import { AuthContext } from "../common/components/auth/authContext/AuthContext"
import { useAppStore } from "@/common/states/store"

export function Logout() {
  const { auth, logout } = useContext(AuthContext);
  const { setProfile } = useAppStore((state) => state.auth);

  useEffect(() => {
    if (auth) {
      sessionStorage.clear()

      localStorage.clear()
      setProfile(null)

      logout()
    }
  }, [auth, logout, setProfile])

  return !auth ? <Navigate to="/login" /> : <div><Loading /></div>
}

export default Logout
